// filepath: client/src/components/layout/CustomerLayout/CustomerLayout.jsx
import { Outlet } from 'react-router';
import CustomerHeader from '#client/components/layout/CustomerHeader/CustomerHeader';
import Footer from '#client/components/layout/Footer/Footer';

const CustomerLayout = () => {
    return (
        <div className="app-container">
            <CustomerHeader />
            <main className="main-content">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default CustomerLayout;
